var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table-input',{attrs:{"fields":[
		{ key: 'shareholder', heading: 'Shareholder' },
		{
			key: 'proportion',
			heading: 'Proportion of Family Owned Shares',
		},
		{ key: 'plan', heading: 'Plan for these shares' },
	],"max-rows":2,"testid":'corporation-exclusion-' + _vm.testid + '-',"hideForEdit":_vm.hideForEdit,"disabled":_vm.disabled},scopedSlots:_vm._u([{key:"shareholder",fn:function({ value, input, index }){return [_c('b-form-select',{class:{ 'custom-disabled': _vm.disabled },attrs:{"size":"sm","options":[..._vm.partnerChoices],"value":value,"data-testid":'corporation-' + _vm.testid + '-partner-shares-' + index,"disabled":_vm.disabled},on:{"input":input}})]}},{key:"plan",fn:function({ value, input, index }){return [_c('b-form-select',{class:{ 'custom-disabled': _vm.disabled },attrs:{"size":"sm","options":[
				{ text: 'Keep their shares', value: 'keep' },
				{
					text: _vm.isUserSeparatingParty? 'Transfer their shares to the other': 'Transfer their shares to the other party',
					value: 'transfer',
				},
				{
					text: 'Rollover their shares to a new company',
					value: 'rollover',
				},
			],"value":value,"data-testid":'corporation-' + _vm.testid + '-plans-for-shares-' + index,"disabled":_vm.disabled},on:{"input":input}})]}},{key:"proportion",fn:function({ value, input, index }){return [_c('b-input-group',{attrs:{"size":"sm","append":"%"}},[_c('b-form-input',{attrs:{"size":"sm","type":"number","value":value,"data-testid":'corporation-' + _vm.testid + '-proportion-' + index,"disabled":_vm.disabled},on:{"change":input}})],1)]}}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }